import Toilet from "@/assets/clients/tempula/room/murti/toilet-1.webp"
import Balcony from "@/assets/clients/tempula/room/murti/balcony-1.webp"
import Balcony2 from "@/assets/clients/tempula/room/murti/balcony-2.webp"
import Balcony3 from "@/assets/clients/tempula/room/murti/balcony-3.webp"
import Misc1 from "@/assets/clients/tempula/room/murti/misc-1.webp"
import Bedrooom1 from "@/assets/clients/tempula/room/murti/bedroom-1.webp"
import Bedrooom2 from "@/assets/clients/tempula/room/murti/bedroom-2.webp"
import Bedrooom3 from "@/assets/clients/tempula/room/murti/bedroom-3.webp"
import Bedrooom4 from "@/assets/clients/tempula/room/murti/bedroom-4.webp"
import Bedrooom5 from "@/assets/clients/tempula/room/murti/bedroom-5.webp"
import Bedrooom6 from "@/assets/clients/tempula/room/murti/bedroom-6.webp"

const murtiConfig = {
    subInfo: "3 guests · 1 bedroom · 1 bed · 1 private bathroom",
    subInfoClass: "text-xl md:text-2xl text-white font-extralight",

    sections: [
        {
            title: "Bedroom",
            images: [Bedrooom1, Bedrooom2, Bedrooom3, Bedrooom4, Bedrooom5, Bedrooom6],
        },
        {
            title: "Bathroom",
            images: [Toilet],
        },
        {
            title: "Balcony",
            images: [Balcony, Balcony2, Balcony3,],
        },
        {
            title: "Miscellaneous",
            images: [Misc1],
        },
    ],

};
export default murtiConfig;
